import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InputItem from '../InputItem';
import Button from '../../atoms/Button';
import { useForm } from '@inertiajs/react';
import { useTheme } from 'styled-components';
import AuthLink from '../../atoms/AuthLink';
import Flex from '../../atoms/Flex';
import { useTranslation } from 'react-i18next';
const LoginForm = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { data, setData, post, processing, errors } = useForm({
        email: '',
        password: '',
    });
    const submit = (e) => {
        e.preventDefault();
        post('/login');
    };
    return (_jsxs("form", { onSubmit: submit, "data-testid": "login-form", children: [_jsx(InputItem, { label: t('user.email'), placeholder: t('user.email_placeholder'), value: data.email, onChange: e => setData('email', e.target.value), disabled: processing, error: errors.email, type: "text" }), _jsx(InputItem, { label: t('users.password_title'), placeholder: "******", value: data.password, onChange: e => setData('password', e.target.value), disabled: processing, error: errors.password, type: "password" }), _jsx(Button, { type: "submit", secondary: true, fullWidth: true, textAlign: "center", isLoading: processing, 
                //@ts-ignore
                loaderColor: theme.primary.dark, children: t('users.sign_in_button') }), _jsx(Flex, { justifyContent: "center", children: _jsx(AuthLink, { href: "/wachtwoord-vergeten", children: t('password_reset.forget_password_button') }) })] }));
};
export default LoginForm;
